import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

import { LoggedUserService } from '@app/services';

export class itemMenu {
    title: string;
    url: any;
    icon: any;
    badgeValue: any;
};

@Injectable({
    providedIn: 'root'
})
export class MenuService {

    routesMenuDisabled = ['/login', '/logout'];
    itemsMenu: Array<itemMenu> = [];
    isEnabled: boolean = false;

    constructor(
        private router: Router,
        private loggedUserService: LoggedUserService
    ) {
        router.events.subscribe((event) => {
            if(event instanceof NavigationStart && this.isEnabled){
                this.isEnabled = this.routesMenuDisabled.indexOf(event.url) === -1;                
            }
            else if(event instanceof NavigationEnd){
                if(this.loggedUserService.loggedUser === null){
                    this.isEnabled = false;
                }
                else if (!this.isEnabled){
                    this.isEnabled = this.routesMenuDisabled.indexOf(event.url) === -1;
                }
            }
        });
    }
    
    refresh() {
        
        let itemsMenu: Array<itemMenu> = [];
        let loggedUser = this.loggedUserService.loggedUser;
        
        itemsMenu.push({
            title: 'HOME',         
            url: 'home',
            icon: 'home-outline',
            badgeValue: null
        });

        itemsMenu.push({
            title: 'PLANNING',            
            url: 'missions-planning',
            icon: 'calendar-outline',
            badgeValue: null
        });

        itemsMenu.push({
            title: 'QUOTAS',            
            url: 'quotas',
            icon: 'pie-chart-outline',
            badgeValue: null
        });

        itemsMenu.push({
            title: 'STORE_DIRECTORY',            
            url: 'stores-directory',
            icon: 'storefront-outline',
            badgeValue: null
        });

        itemsMenu.push({
            title: 'PHOTOS_GALLERY',            
            url: 'photos-gallery',
            icon: 'images-outline',
            badgeValue: null
        });

        if (loggedUser?.pbiEmbedAllowed){
            itemsMenu.push({
                title: 'REPORTING',            
                url: 'reporting',
                icon: 'bar-chart-outline',
                badgeValue: null
            });
        }
        
        this.itemsMenu = itemsMenu;
    }
        
}

